import _ from 'lodash'

import {
  APPEND_MESSAGE,
  REMOVE_MESSAGE,
  REPLACE_MESSAGE,
  SET_CHAT_FILTERS,
  SEND_MESSAGE_START,
  SEND_MESSAGE_RESET,
  SET_USER_CHATROOMS,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_FAILURE,
  NEW_CONVERSATION_START,
  SET_ACTIVE_CONVERSATION,
  NEW_CONVERSATION_SUCCESS,
  NEW_CONVERSATION_FAILURE,
  START_CONVERSATION_START,
  FETCH_CHAT_MESSAGE_START,
  SET_UNREAD_MESSAGE_COUNT,
  DELETE_CONVERSATION_START,
  START_CONVERSATION_SUCCESS,
  START_CONVERSATION_FAILURE,
  FETCH_CHAT_MESSAGE_SUCCESS,
  FETCH_CHAT_MESSAGE_FAILURE,
  FETCH_USER_CHATROOMS_START,
  DELETE_CONVERSATION_FAILURE,
  DELETE_CONVERSATION_SUCCESS,
  SEND_MESSAGE_SET_INPUT_DATA,
  FETCH_USER_CHATROOMS_SUCCESS,
  FETCH_USER_CHATROOMS_FAILURE,
  UNLOCK_MESSAGE_PAYMENT_START,
  GET_BULK_SEND_USERS_START,
  GET_BULK_SEND_USERS_SUCCESS,
  GET_BULK_SEND_USERS_FAILURE,
  GET_BULK_SEND_METADATA_START,
  GET_BULK_SEND_METADATA_SUCCESS,
  UNLOCK_MESSAGE_PAYMENT_FAILURE,
  UNLOCK_MESSAGE_PAYMENT_SUCCESS,
  GET_BULK_SEND_METADATA_FAILURE,
  SET_ACTIVE_CONVERSATION_LOADING,
  SET_CHATROOMS_USER_ONLINE_STATUS,
  SET_ACTIVE_CONVERSATION_IF_CURRENT,
  GET_BULK_SEND_USERS_TOGGLE_SELECTED,
  SET_ACTIVE_CHATROOM_USER_ONLINE_STATUS,
} from '../actions/ActionConstant'
import ChatroomHelper, { getChatroomMember } from '../../helpers/socket/chatroom'
import { mergeListOfUsers } from '../../components/helper/Utils'
import { ChatroomsFilter } from '../../components/Messages/MessageIndex'
import { BulkUsersFilter, SidebarListTypes } from '../../helpers/constants/message'
import { mergeUnique, appendMessges, appendChatrooms } from '../../helpers/array/array'

const initialState = {
  unreadMessageCount: 0,
  chatrooms: {
    data: [],
    error: null,
    selected: [],
    loading: false,
    allowSelection: false
  },
  messages: {
    data: {},
    error: false
  },
  sendMessage: {
    data: {},
    error: null,
    inputData: {
      text: '',
      assets: []
    },
    loading: false
  },
  activeConversation: {
    member: {},
    chatroom: {},
    loading: false
  },
  bulkSendUsers: {
    data: [],
    selected: [],
    loading: true,
    error: false
  },
  bulkSendMetadata: {
    data: {},
    loading: true,
    error: false
  },
  startConversation: {
    data: {},
    error: null,
    loading: false
  },
  deleteConversation: {
    data: {},
    error: null,
    loading: false
  },
  newConverstaionUsers: {
    data: {
      result: [],
      metadata: {}
    },
    error: null,
    inputData: {},
    loading: false
  },
  messageUnlockPaymentWallet: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false
  },
  chatFilters: {
    chatroomSearhcQuery: '',
    chatroomsFilter: ChatroomsFilter.Active,
    bulkUsersFilter: BulkUsersFilter.Active,
    sidebarListType: SidebarListTypes.Chatrooms,
  }
}

function replaceMessage(records, message) {
  const { chatroom_id } = message
  const messageList = records[chatroom_id]?.messages || []
  return messageList.map((record) => {
    if (record.id === message.id) {
      return message
    }
    return record
  })
}

const ChatReducer = (state = initialState, action) => {
  switch (action.type) {
    case NEW_CONVERSATION_START:
      return {
        ...state,
        newConverstaionUsers: {
          data: {
            ...state.newConverstaionUsers.data,
            result:
              action.data?.q === state.newConverstaionUsers.inputData?.q
                ? state.newConverstaionUsers.data.result
                : []
          },
          inputData: action.data,
          loading: true,
          error: null
        }
      }
    case NEW_CONVERSATION_SUCCESS:
      return {
        ...state,
        newConverstaionUsers: {
          data: {
            result: mergeListOfUsers(
              state.newConverstaionUsers.data.result || [],
              action.data.result || []
            ),
            metadata: action.data?.metadata
          },
          loading: false,
          error: null
        }
      }
    case NEW_CONVERSATION_FAILURE:
      return {
        ...state,
        newConverstaionUsers: {
          ...state.newConverstaionUsers,
          loading: true,
          error: action.error
        }
      }
    case START_CONVERSATION_START:
      return {
        ...state,
        startConversation: {
          data: null,
          error: null,
          loading: true
        }
      }
    case START_CONVERSATION_SUCCESS:
      return {
        ...state,
        startConversation: {
          data: action.data,
          loading: false,
          error: null
        }
      }
    case START_CONVERSATION_FAILURE:
      return {
        ...state,
        startConversation: {
          data: null,
          loading: false,
          error: action.data
        }
      }
    case SEND_MESSAGE_START:
      return {
        ...state,
        sendMessage: {
          ...state.sendMessage,
          error: null,
          loading: true
        }
      }
    case SEND_MESSAGE_RESET:
      return {
        ...state,
        sendMessage: {
          data: {},
          error: null,
          inputData: {
            text: '',
            price: 0,
            assets: []
          },
          loading: false
        }
      }
    case SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        sendMessage: {
          data: action.data,
          error: null,
          inputData: {
            text: '',
            price: 0,
            assets: []
          },
          loading: false
        }
      }
    case SEND_MESSAGE_FAILURE:
      return {
        ...state,
        sendMessage: {
          data: {},
          error: action.data,
          inputData: {
            text: '',
            price: 0,
            assets: []
          },
          loading: false
        }
      }
    case SEND_MESSAGE_SET_INPUT_DATA:
      return {
        ...state,
        sendMessage: {
          ...state.sendMessage,
          inputData: {
            ...state.sendMessage.inputData,
            ...action.data
          }
        }
      }
    case DELETE_CONVERSATION_START:
      return {
        ...state,
        deleteConversation: {
          ...state.deleteConversation,
          error: null,
          loading: true
        }
      }
    case DELETE_CONVERSATION_SUCCESS:
      return {
        ...state,
        deleteConversation: {
          ...state.deleteConversation,
          loading: false,
          data: action.data
        }
      }
    case DELETE_CONVERSATION_FAILURE:
      return {
        ...state,
        deleteConversation: {
          ...state.deleteConversation,
          loading: false,
          error: action.data
        }
      }
    case FETCH_USER_CHATROOMS_START:
      return {
        ...state,
        chatrooms: {
          ...state.chatrooms,
          loading: true,
          error: null
        }
      }
    case FETCH_USER_CHATROOMS_SUCCESS:
      return {
        ...state,
        chatrooms: {
          data: {
            ...action.data,
            result: appendChatrooms(state.chatrooms?.data, action?.data)
          },
          loading: false,
          error: null
        }
      }
    case FETCH_USER_CHATROOMS_FAILURE:
      return {
        ...state,
        chatrooms: {
          ...state.chatrooms,
          loading: true,
          error: action.error
        }
      }
    case FETCH_CHAT_MESSAGE_START:
      return {
        ...state,
        messages: {
          error: null,
          data: {
            ...state.messages.data,
            [action.data.chatroom_id]: {
              ...state.messages.data[action.data.chatroom_id],
              loading: true
            }
          }
        }
      }
    case FETCH_CHAT_MESSAGE_SUCCESS:
      return {
        ...state,
        messages: {
          error: false,
          data: {
            ...state.messages.data,
            [action.data.chatroom_id]: {
              loading: false,
              messages: state.messages.data[action.data.chatroom_id]?.messages
                ? appendMessges(
                    state.messages.data[action.data.chatroom_id]?.messages.reverse() ||
                      [],
                    action.data?.messages?.result
                      ? action.data?.messages?.result
                      : []
                  )
                : action.data?.messages?.result || [],
              page: action.data.messages?.metadata?.pagination?.page || 1,
              numberOfPages:
                action.data.messages?.metadata?.pagination?.numberOfPages || 1
            }
          }
        }
      }
    case FETCH_CHAT_MESSAGE_FAILURE:
      return {
        ...state,
        messages: {
          ...state.messages,
          error: action.error
        }
      }
    case APPEND_MESSAGE:
      const messages =
        state.messages.data[action.data.chatroom_id]?.messages || []
      return {
        ...state,
        messages: {
          data: {
            [action.data.chatroom_id]: {
              ...state.messages.data[action.data.chatroom_id],
              messages: mergeUnique(messages, [action.data])
            }
          },
          error: false,
          buttonDisable: false,
          loadingButtonContent: null
        }
      }
    case REMOVE_MESSAGE:
      const { chatroom_id, message_id } = action.data
      const messageList = state.messages.data[chatroom_id]?.messages || []
      return {
        ...state,
        messages: {
          data: {
            [chatroom_id]: {
              ...state.messages.data[chatroom_id],
              messages: messageList.filter(
                (message) => message.id.toString() !== message_id.toString()
              )
            }
          },
          error: false,
          buttonDisable: false,
          loadingButtonContent: null
        }
      }
    case REPLACE_MESSAGE:
      return {
        ...state,
        messages: {
          data: {
            [action.data?.chatroom_id]: {
              ...state.messages.data[action.data?.chatroom_id],
              messages: replaceMessage(state.messages.data, action.data)
            }
          },
          error: false,
          buttonDisable: false,
          loadingButtonContent: null
        }
      }
    case SET_USER_CHATROOMS:
      return {
        ...state,
        chatrooms: {
          ...state.chatrooms,
          data: action.data
        }
      }
    case SET_ACTIVE_CONVERSATION:
      return {
        ...state,
        activeConversation: {
          loading: false,
          member: action.data?.member || state?.activeConversation?.member,
          chatroom: action.data?.chatroom || state?.activeConversation?.chatroom
        }
      }
    case SET_ACTIVE_CONVERSATION_LOADING:
      return {
        ...state,
        activeConversation: {
          ...state.activeConversation,
          loading: true
        }
      }
    case SET_ACTIVE_CONVERSATION_IF_CURRENT:
      return {
        ...state,
        activeConversation: action?.data?.id?.toString() === state.activeConversation.chatroom?.id?.toString() ? ({
          loading: false,
          member:  getChatroomMember(action.data),
          chatroom: _.merge(state?.activeConversation?.chatroom, action.data)
        }) : state.activeConversation
      }
    case SET_CHATROOMS_USER_ONLINE_STATUS:
      return {
        ...state,
        chatrooms: {
          data: ChatroomHelper.setMultipleChatroomsOnlineStatus(
            state.chatrooms.data,
            action.data
          ),
          loading: false,
          error: null
        }
      }
    case SET_ACTIVE_CHATROOM_USER_ONLINE_STATUS:
      return {
        ...state,
        activeConversation: {
          data: ChatroomHelper.setChatroomOnlineStatus(
            state.activeConversation.data,
            action.data
          )
        }
      }
    case UNLOCK_MESSAGE_PAYMENT_START:
      return {
        ...state,
        messageUnlockPaymentWallet: {
          inputData: action.data,
          data: {},
          loading: true,
          error: false,
          loadingButtonContent: 'Loading... Please wait',
          buttonDisable: true
        }
      }
    case UNLOCK_MESSAGE_PAYMENT_SUCCESS:
      return {
        ...state,
        messageUnlockPaymentWallet: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false
        }
      }
    case UNLOCK_MESSAGE_PAYMENT_FAILURE:
      return {
        ...state,
        messageUnlockPaymentWallet: {
          data: {},
          loading: false,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false
        }
      }
    case GET_BULK_SEND_USERS_START:
      return {
        ...state,
        bulkSendUsers: {
          data: [],
          selected: [],
          error: false,
          loading: true
        }
      }
    case GET_BULK_SEND_USERS_SUCCESS:
      return {
        ...state,
        bulkSendUsers: {
          error: false,
          loading: false,
          data: action.data,
          selected: action.data.map(({ id }) => id)
        }
      }
    case GET_BULK_SEND_USERS_FAILURE:
      return {
        ...state,
        bulkSendUsers: {
          data: [],
          selected: [],
          loading: false,
          error: action.error
        }
      }
    case GET_BULK_SEND_USERS_TOGGLE_SELECTED:
      return {
        ...state,
        bulkSendUsers: {
          ...state.bulkSendUsers,
          selected: state.bulkSendUsers.selected.includes(action.data)
            ? state.bulkSendUsers.selected.filter((id) => id !== action.data)
            : [...state.bulkSendUsers.selected, action.data]
        }
      }
    case GET_BULK_SEND_METADATA_START:
      return {
        ...state,
        bulkSendMetadata: {
          ...state.bulkSendMetadata,
          data: {},
          error: false,
          loading: true
        }
      }
    case GET_BULK_SEND_METADATA_SUCCESS:
      return {
        ...state,
        bulkSendMetadata: {
          ...state.bulkSendMetadata,
          error: false,
          loading: false,
          data: action.data
        }
      }
    case GET_BULK_SEND_METADATA_FAILURE:
      return {
        ...state,
        bulkSendMetadata: {
          ...state.bulkSendMetadata,
          data: {},
          loading: false,
          error: action.error
        }
      }
    case SET_CHAT_FILTERS:
      return {
        ...state,
        chatFilters: {
          ...state.chatFilters,
          ...action.data
        }
      }
    case SET_UNREAD_MESSAGE_COUNT:
      return {
        ...state,
        unreadMessageCount: action.data
      }
    default:
      return state
  }
}

export default ChatReducer
